import { Injectable } from '@angular/core';
import { GeneratedRecordAnswers } from '@repo/backend-api-spec';
import { lastValueFrom } from 'rxjs';
import { BaseAPI, BaseRequestOptions } from './base-api';

/**
 * Not provided in root, unlike the other API services: the game injects it optionally and only reports answers
 * where an app provides a concrete subclass for it.
 */
@Injectable()
export abstract class MeasurementApiService extends BaseAPI {
  public async recordAnswers(data: GeneratedRecordAnswers) {
    return await lastValueFrom(
      this.post<GeneratedRecordAnswers, void, 'BAD_REQUEST' | 'RESOURCE_NOT_FOUND'>('/measurements/answers', {
        ...this.requestOptions(),
        body: data,
      }),
    );
  }

  /** Added to every request, for a subclass that authenticates differently. Asked for on each request. */
  protected requestOptions(): Pick<BaseRequestOptions, 'headers' | 'context'> {
    return {};
  }
}
